<template>
  <delimited-list
      :items="value"
      :separator="''"
      :container-width="columnConfig?.width"
  >
    <template #list-item="{ item }">
      <redesign-tag
          :border-color="'primary'"
          :tag-content="[{ iconName: '', text: getValueKey(item) }]"
          class="mr-2"
      />
    </template>
    <template #other-tooltip-content="{ list }">
      <template v-for="item in list">
        <div
            class="block mb-2 border p-1 border-r-2"
            v-html="getTooltip(item)"
        />
      </template>
    </template>
    <template #other-content="{list}">
      <redesign-tag
          :border-color="'primary'"
          :tag-content="[{ iconName: '', text: `+${list.length}` }]"
          class="mr-2"
      />
    </template>
  </delimited-list>
</template>

<script setup lang="ts">
import RedesignTag from '@/components/RedesignBaseComponents/RedesignTag.vue'
import DelimitedList from '@/components/RedesignBaseComponents/DelimitedList.vue'
import { getValueKey, getTooltip } from '@/helpers/delimitedListHelpers'
import { ColumnConfig, WidgetTemplateColumnWithConfig } from '@/types/dashboard'

const props = defineProps<{
  value: unknown[]
  column: WidgetTemplateColumnWithConfig
  columnConfig: ColumnConfig
}>()
</script>
